var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('register-header',{attrs:{"state":1}}),_c('div',{staticClass:"register-content"},[_c('div',{staticClass:"register-box"},[_c('span',{staticClass:"box-title"},[_vm._v("成为企业用户")]),_c('enterprise-form',{attrs:{"state":-1}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }